import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './Login'
import RTL from "./RTL";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Label from './Label'
import * as serviceWorker from './serviceWorker';


import { createBrowserHistory } from 'history'

const history = createBrowserHistory()

const cookies = new Cookies();
// cookies.remove('login_user')
// var Router = require('react-router');
ReactDOM.render(
  <RTL>
  <React.StrictMode>
    {/* < /> */}
    {cookies.get('login_user') === undefined ? [
      <BrowserRouter>
      <Switch>
        <Route path="/login" component={Login} />
      </Switch>
    </BrowserRouter>,
      history.push('/login') ]:
    <BrowserRouter>
      <Switch>
        <Route path="/" component={Label} exact />
        <Route path="/login" component={Login} />
      </Switch>
    </BrowserRouter>
    }
  </React.StrictMode>
  </RTL>,
  document.getElementById('root')
  
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
